import { useState, useEffect } from "react";
import Logo from "../../User/helper/logo.png";
import {
  MDBContainer,
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarToggler,
  MDBIcon,
  MDBNavbarNav,
  MDBCollapse,
  MDBNavbarItem,
} from "mdb-react-ui-kit";
import { Link, useNavigate } from "react-router-dom";
import { REELS_URL } from "../../backend";

const Header = ({ loggedIn }) => {
  const [showBasic, setShowBasic] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navi = useNavigate();
  let scrollY = 0;

  const overlayActive = showBasic || isAnimating;

  useEffect(() => {
    const checkScreenSize = () => setIsMobile(window.innerWidth < 640);
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  useEffect(() => {
    if (overlayActive) {
      scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.overflow = "hidden";
      document.body.style.width = "100%";
    } else {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.overflow = "";
      document.body.style.width = "";
      window.scrollTo(0, scrollY);
    }
    return () => {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.overflow = "";
      document.body.style.width = "";
    };
  }, [overlayActive]);

  const links = [
    { to: "/speech",   label: "Discourses प्रवचन" },
    { to: "/images",   label: "Photo Gallery फोटो गैलरी" },
    { to: "/vedios",   label: "Videos विडियोज" },
    { to: "/songs",    label: "Songs भजन" },
    { to: "/document", label: "Ebooks ई-बुक्स" },
    { to: "/",         label: "Hare Krishna Mandir, Pune" },
    { to: "/",         label: "Hare Krishna Mandir Trust" },
    { to: "/",         label: "Contact us" },
    { to: REELS_URL,  label: "HKM Reels", reloadDocument: true },
  ];

  // Logged-in nav: Profile added, Logout REMOVED from UI
  // To logout: visit /devlogout (devs only — not shown to users)
  const loggedInLinks = [
    ...links,
    {
      to: "/userprofile",
      label: "Profile",
      onClick: () => navi("/userprofile"),
    },
  ];

  const navLinks = loggedIn ? loggedInLinks : links;

  const linkStyle = {
    padding: "0.75rem 0",
    textDecoration: "none",
    width: "100%",
    textAlign: "center",
    cursor: "pointer",
    transition: "background-color 0.2s ease, transform 0.1s ease",
    color: "#E34607",
    fontWeight: 500,
    fontSize: 18,
  };

  const handleDrawerToggle = () => {
    if (showBasic) {
      setIsAnimating(true);
      setTimeout(() => setIsAnimating(false), 350);
    }
    setShowBasic(!showBasic);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <style>{`
        .mobile-nav-link:hover { background-color: #f0f0f0; }
        .mobile-nav-link:active { background-color: #e0e0e0; transform: scale(0.98); }
        .custom-navbar-overlay {
          position: fixed !important;
          top: 64px; left: 0;
          width: 100vw;
          height: calc(100vh - 64px);
          background: rgba(255,255,255,0.98);
          z-index: 2001;
          transition: all 0.2s;
          overflow-y: auto;
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .custom-navbar-overlay::-webkit-scrollbar { display: none; }
      `}</style>

      <MDBNavbar light bgColor="light" style={{
        position: "sticky", top: 0, left: 0,
        width: "100%", zIndex: 1200,
        transition: "all 0.15s ease-in-out",
      }}>
        <MDBContainer fluid style={{
          display: "flex", flexDirection: "column",
          alignItems: "stretch", padding: 0,
        }}>
          <div style={{
            display: "flex", justifyContent: "space-between",
            alignItems: "center", padding: "0.5rem 1rem", height: 64,
          }}>
            <MDBNavbarBrand tag={Link} to="/" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
              <img src={Logo} alt="logo" height="30px" />
            </MDBNavbarBrand>

            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>

              {/* Desktop: Login button (not logged in) */}
              {!loggedIn && !isMobile && (
                <button
                  onClick={() => navi("/signin")}
                  style={{
                    background: "#E34607", color: "white",
                    border: "none", borderRadius: "6px",
                    padding: "8px 16px", fontSize: "14px",
                    fontWeight: "500", cursor: "pointer",
                    transition: "background-color 0.2s ease",
                  }}
                  onMouseEnter={(e) => { e.target.style.background = "#d13a06"; }}
                  onMouseLeave={(e) => { e.target.style.background = "#E34607"; }}
                >
                  Login
                </button>
              )}

              {/* Desktop: Profile icon (logged in) */}
              {loggedIn && !isMobile && (
                <button
                  onClick={() => navi("/userprofile")}
                  style={{
                    background: "transparent", color: "#E34607",
                    border: "2px solid #E34607", borderRadius: "50%",
                    padding: "8px", width: "40px", height: "40px",
                    cursor: "pointer", transition: "all 0.2s ease",
                    display: "flex", alignItems: "center", justifyContent: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#E34607";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "transparent";
                    e.target.style.color = "#E34607";
                  }}
                >
                  <MDBIcon icon="user" fas style={{ fontSize: "16px" }} />
                </button>
              )}

              <MDBNavbarToggler
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
                onClick={handleDrawerToggle}
              >
                {showBasic
                  ? <MDBIcon icon="times" fas style={{ color: "#E34607" }} />
                  : <MDBIcon icon="bars"  fas style={{ color: "#E34607" }} />}
              </MDBNavbarToggler>
            </div>
          </div>

          <MDBCollapse navbar show={showBasic}
            className={overlayActive ? "custom-navbar-overlay" : ""}
          >
            <MDBNavbarNav style={{
              display: "flex", flexDirection: "column",
              alignItems: "center", padding: "1rem 0",
              background: "#f8f9fa", width: "100%",
            }}>
              {navLinks.map((link) => (
                <Link
                  to={link.to} key={link.label}
                  reloadDocument={link.reloadDocument}
                  className="mobile-nav-link"
                  onClick={() => { setShowBasic(false); if (link.onClick) link.onClick(); }}
                  style={linkStyle}
                >
                  <MDBNavbarItem style={{ color: "#E34607", fontWeight: 600 }}>
                    {link.label}
                  </MDBNavbarItem>
                </Link>
              ))}

              {/* Mobile: Login link (not logged in) */}
              {!loggedIn && isMobile && (
                <Link
                  to="/signin"
                  className="mobile-nav-link"
                  onClick={() => setShowBasic(false)}
                  style={linkStyle}
                >
                  <MDBNavbarItem style={{ color: "#E34607", fontWeight: 600 }}>
                    Login
                  </MDBNavbarItem>
                </Link>
              )}
            </MDBNavbarNav>
          </MDBCollapse>
        </MDBContainer>
      </MDBNavbar>
    </>
  );
};

export default Header;